export function setUser(state, user) {
   state.user = user
   state.is_logged = true
}

export function setActor(state, actor) {
  state.actor = actor
}

 export function setStateAccessToken(state, token) {
  state.access_token = token;
}

 export function cleanSession(state) {
   state.user = null
   state.actor = null
   state.is_logged = false
   state.access_token = null
   state.logged_at = null
 }
 